<template>
	<v-dialog
		v-model="show"
		v-if="show"
		@keydown.esc="show = false"
		max-width="500"
	>
		<v-card>
			<v-card-title class="error body-2 white--text">
				{{ titleText }}
			</v-card-title>
			<template v-if="countSelectedArticles > 1">
				<v-card-text style="max-height: 400px; overflow-y: scroll;">
					<h4 class="mb-2">Articles to be deleted:</h4>
					<ul>
						<li
							v-for="article in articles"
							:key="article.id"
						>
							"{{ article.titleText }}"
						</li>
					</ul>
				</v-card-text>
				<v-divider/>
			</template>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="error"
					flat
					@click="deleteArticle()"
				>
					OK
				</v-btn>
				<v-btn
					flat
					@click="show = false"
				>
					Cancel
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify';
import { Articles } from '@/models/Article';

export default {
	computed: {
		show: sync('articlesDeleteDialog/show'),
		articles: sync('articlesDeleteDialog/articles'),
		currentReport() {
			return this.$store.get('reports/currentReport');
		},
		allArticlesInReport() {
			return (this.$store.get('articles') || []);
		},
		areAllArticlesSelected() {
			return (this.allArticlesInReport.length === this.countSelectedArticles);
		},
		countSelectedArticles() {
			return (!this.articles ? 0 : this.articles.length);
		},
		titleText() {
			const reportName = this.currentReport.displayName;

			// Single article to delete
			if (this.countSelectedArticles === 1) {
				return `This will delete "${this.articles[0].titleText}" in "${reportName}" report.`;
			}

			// Some articles to delete
			if (this.areAllArticlesSelected) {
				return `This will delete ALL articles in "${reportName}" report.`;
			}

			// All articles to delete
			return `This will delete ${this.countSelectedArticles} articles in "${reportName}" report.`;
		},
	},
	methods: {
		deleteArticle() {
			var articles = new Articles();
			articles.add(this.articles);
			articles.deleteArticles(this.currentReport);

			this.show = false;
		},
	}
};
</script>

<style></style>
